
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[name]/[id]/news",
      function () {
        return require("private-next-pages/team/[name]/[id]/news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[name]/[id]/news"])
      });
    }
  